<template>
  <DeepSignUserContext>
    <template #default="{ user }">
      <v-row>
        <v-col cols="12" lg="8">
          <AccountSignature v-if="user"></AccountSignature>
        </v-col>
      </v-row>
    </template>
  </DeepSignUserContext>
</template>

<script setup lang="ts">
import AccountSignature from '@/components/deepadmin/signature/AccountSignature.vue'
import DeepSignUserContext from '@/components/deepSign/user/DeepSignUserContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.personal.my_signature',
  },
})
</script>
